import i18n from '../i18n'

export interface ValidationResult {
 isValid: boolean
 errors: Record<string, string>
}

export type Step1BranchContext = {
 id: string
 allowedVehicleCategories?: string[]
}

export const validateStep1 = (formData: any, branches?: Step1BranchContext[]): ValidationResult => {
 const errors: Record<string, string> = {}

 if (!formData.branchId || !String(formData.branchId).trim()) {
 errors.branchId = i18n.t('vehicles.validation.branchRequired')
 }

 const branch = branches?.find(b => b.id === formData.branchId)
 const allowed = branch?.allowedVehicleCategories
 const whitelist =
  allowed && allowed.length > 0 ? allowed : null

 if (!formData.category || !String(formData.category).trim()) {
 errors.category = i18n.t('vehicles.validation.categoryRequired')
 } else if (whitelist && !whitelist.includes(formData.category)) {
 errors.category = i18n.t('vehicles.validation.categoryNotAllowedForBranch')
 }

 // Nome do veículo - obrigatório
 if (!formData.name?.trim()) {
 errors.name = 'Nome do veículo é obrigatório'
 }

 // Marca - obrigatória
 if (!formData.brandId || !formData.brandId.trim()) {
 errors.brand = 'Marca é obrigatória - selecione uma marca da lista'
 }

 // Modelo - obrigatório
 if (!formData.modelId || !formData.modelId.trim()) {
 errors.model = 'Modelo é obrigatório - selecione um modelo da lista'
 }

 // Condição - obrigatória
 if (!formData.condition || !formData.condition.trim()) {
 errors.condition = 'Condição é obrigatória - selecione se o veículo é novo ou usado'
 }

 // Ano de fabricação - obrigatório e validação de range
 if (!formData.manufactureYear || !formData.manufactureYear.toString().trim()) {
 errors.manufactureYear = 'Ano de fabricação é obrigatório'
 } else {
 const year = parseInt(formData.manufactureYear)
 const currentYear = new Date().getFullYear()
 if (isNaN(year)) {
 errors.manufactureYear = 'Ano de fabricação deve ser um número válido'
 } else if (year < 1900 || year > currentYear + 1) {
 errors.manufactureYear = `Ano deve estar entre 1900 e ${currentYear + 1}`
 }
 }

 // Ano modelo - obrigatório e validação de range
 if (!formData.modelYear || !formData.modelYear.toString().trim()) {
 errors.modelYear = 'Ano modelo é obrigatório'
 } else {
 const year = parseInt(formData.modelYear)
 const currentYear = new Date().getFullYear()
 if (isNaN(year)) {
 errors.modelYear = 'Ano modelo deve ser um número válido'
 } else if (year < 1900 || year > currentYear + 1) {
 errors.modelYear = `Ano deve estar entre 1900 e ${currentYear + 1}`
 } else if (formData.manufactureYear) {
 const manufactureYear = parseInt(formData.manufactureYear)
 if (!isNaN(manufactureYear) && year < manufactureYear) {
 errors.modelYear = 'Ano modelo não pode ser menor que o ano de fabricação'
 } else if (!isNaN(manufactureYear) && year > manufactureYear + 1) {
 errors.modelYear = 'Ano modelo pode ser no máximo 1 ano maior que o ano de fabricação'
 }
 }
 }

 // Quilometragem - obrigatória (exceto para veículos 0km)
 if (formData.condition !== 'new_vehicle') {
 if (!formData.mileage || !formData.mileage.toString().trim()) {
 errors.mileage = 'Quilometragem é obrigatória para veículos usados'
 } else {
 // Remove pontos e vírgulas para validar o número
 const mileageClean = formData.mileage.toString().replace(/[.,]/g, '')
 const mileageNumber = parseInt(mileageClean)
 if (isNaN(mileageNumber)) {
 errors.mileage = 'Quilometragem deve ser um número válido'
 } else if (mileageNumber < 0) {
 errors.mileage = 'Quilometragem não pode ser negativa'
 }
 }
 }

 return {
 isValid: Object.keys(errors).length === 0,
 errors
 }
}

export const validateStep2 = (formData: any): ValidationResult => {
 const errors: Record<string, string> = {}

 // Preço - obrigatório e deve ser maior que 0
 if (!formData.price || !formData.price.toString().trim()) {
 errors.price = 'Preço de venda é obrigatório'
 } else {
 const priceClean = formData.price.toString()
 .replace('R$', '')
 .replace(/\s/g, '')
 .replace(/\./g, '')
 .replace(',', '.')
 .trim()
 
 const priceNumber = parseFloat(priceClean)
 
 if (isNaN(priceNumber)) {
 errors.price = 'Preço deve ser um número válido'
 } else if (priceNumber <= 0) {
 errors.price = 'Preço deve ser maior que zero'
 }
 }

 // Status - obrigatório
 if (!formData.status || !formData.status.trim()) {
 errors.status = 'Status é obrigatório - selecione ao menos uma opção'
 }

 return {
 isValid: Object.keys(errors).length === 0,
 errors
 }
}

export const validateStep3 = (formData: any): ValidationResult => {
 const errors: Record<string, string> = {}

 // Validações para carros (não motos)
 if (formData.category !== 'A') {
 if (!formData.fuelType) {
 errors.fuelType = 'Tipo de combustível é obrigatório'
 }

 if (!formData.transmission) {
 errors.transmission = 'Transmissão é obrigatória'
 }
 }

 return {
 isValid: Object.keys(errors).length === 0,
 errors
 }
}

export const validateStep4 = (formData: any): ValidationResult => {
  const errors: Record<string, string> = {}

  console.log('🔍 Validando Step 4')
  console.log('📋 isInspected:', formData.isInspected)
  console.log('📋 inspectionDate:', formData.inspectionDate)
  console.log('📋 isAuction:', formData.isAuction)
  console.log('📋 auctionCategory:', formData.auctionCategory)

  // Documentos não são obrigatórios - removido conforme solicitação
  // const documents = formData.documents || []
  // if (documents.length === 0) {
  //   errors.documents = 'Documento do veículo é obrigatório - envie pelo menos um documento (CRLV, nota fiscal, etc)'
  // }

 // Se veículo está marcado como vistoriado, a data é obrigatória
 if (formData.isInspected === true) {
 if (!formData.inspectionDate || formData.inspectionDate.trim() === '') {
 errors.inspectionDate = 'Data de vistoria é obrigatória quando o veículo foi vistoriado'
 console.log('❌ Data de vistoria obrigatória não preenchida')
 } else {
 const inspectionDate = new Date(formData.inspectionDate)
 const today = new Date()
 today.setHours(23, 59, 59, 999)
 
 if (inspectionDate > today) {
 errors.inspectionDate = 'Data de vistoria não pode ser futura'
 console.log('❌ Data de vistoria é futura')
 }
 }
 }

 // Se veículo é de leilão, validar campos obrigatórios
 if (formData.isAuction === true) {
 if (!formData.auctionCategory || formData.auctionCategory.trim() === '') {
 errors.auctionCategory = 'Categoria de leilão é obrigatória'
 console.log('❌ Categoria de leilão não preenchida')
 }
 
 if (!formData.auctionSubtype || formData.auctionSubtype.trim() === '') {
 errors.auctionSubtype = 'Subtipo de leilão é obrigatório'
 console.log('❌ Subtipo de leilão não preenchido')
 }
 
 if (!formData.auctionDamageLevel || formData.auctionDamageLevel.trim() === '') {
 errors.auctionDamageLevel = 'Nível de avaria é obrigatório'
 console.log('❌ Nível de avaria não preenchido')
 }
 }

 // Descrição é obrigatória
 if (!formData.description || formData.description.trim() === '') {
 errors.description = 'Descrição do veículo é obrigatória'
 console.log('❌ Descrição não preenchida')
 }

 console.log('📊 Erros encontrados no Step 4:', errors)
 console.log('✅ Step 4 válido:', Object.keys(errors).length === 0)

 return {
 isValid: Object.keys(errors).length === 0,
 errors
 }
}

export const validateStep5 = (): ValidationResult => {
 // Step 5 é fotos e mídias - não tem campos obrigatórios
 return {
 isValid: true,
 errors: {}
 }
}

export const validateStep6 = (): ValidationResult => {
 // Step 6 é o resumo - NUNCA valida nada, apenas exibe informações
 return {
 isValid: true,
 errors: {}
 }
}

export const getStepValidator = (step: number) => {
 switch (step) {
 case 1:
 return validateStep1
 case 2:
 return validateStep2
 case 3:
 return validateStep3
 case 4:
 return validateStep4
 case 5:
 return validateStep5
 case 6:
 return validateStep6
 default:
 return () => ({ isValid: true, errors: {} })
 }
}

